import React from 'react';
interface StatBlockProps {
  stat: string;
  caption: string;
}
export function StatBlock({
  stat,
  caption
}: StatBlockProps) {
  return <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 my-12 p-8 bg-beige/50 rounded-2xl border border-taupe/30" data-id="element-223">
      <div className="text-5xl sm:text-6xl font-serif font-medium text-forest flex-shrink-0" data-id="element-224">
        {stat}
      </div>
      <div className="text-ink/80 leading-relaxed text-center sm:text-left" data-id="element-225">
        {caption}
      </div>
    </div>;
}